
<div v-if="produitCollection" :class="jel_getClassObject(content)">
  <b-container v-if="arrayIdProduit" fluid class="menu-droit mw-100 p-0 d-flex-column mt-1">
    <b-row class="mw-100 m-0 border-bottom">
      <b-col cols="12" class="px-0">
        <div v-if="afficherFlechesNavigation" class="navigation">
          <b-button v-if="positionListe > 0" class="fleche gauche" @click="scrollListeAGauche()">
            <svg-icon scale="0.7" icon-name="fleche-gauche" />
          </b-button>
          <b-button
            v-if="afficherFlecheDroite"
            class="fleche droite"
            @click="scrollListeADroite()"
          >
            <svg-icon class="rotation180" scale="0.7" icon-name="fleche-gauche" />
          </b-button>
        </div>
        <div
          ref="liste-collections"
          class="liste-boutons-collections d-flex overflow-auto py-1 ml-2"
        >
          <b-button
            v-for="(produit, index) in produitCollection"
            :key="produit['@id']"
            :ref="produitCollection[index]['@name']"
            pill
            class="bouton-collection mb-0 mr-1 px-2 py-1"
            :class="{
              'bouton-actif': listeAffichee == index,
              'd-none': !isBonEtatConnexion(index),
            }"
            @click="[(listeAffichee = index), getPrefs(index)]"
            @click.capture="gaPreventClick(index)"
            >{{ libBouton(index) }}
          </b-button>
        </div>
        <div
          v-if="afficherFlechesNavigation"
          class="degrade position-absolute w-100 h-100"
          :class="afficherFlecheDroite ? 'droite' : 'gauche'"
        />
      </b-col>
      <b-col
        v-for="(uuidProduit, index) in arrayIdProduit[listeAffichee]"
        :key="index"
        class="col-6 itemCollection liste-2-colonnes"
        :class="index % 2 == 0 ? 'pr-0 pl-1' : 'pl-0 pr-1'"
      >
        <MediaImageLogoProduitCasino3x4 :content="{ idProduit: uuidProduit }" />
      </b-col>
    </b-row>
  </b-container>
</div>
